import React from "react";
import '../../src/layouts/styles/processsection.css';
import SeoHead from '../shared/seo/SeoHead';
import { HomeSeo } from '../shared/seo/HomeSeo';
import { HeroSliderPublic } from '../modules/heroSlider/components/HeroSliderPublic';
import { CategoryShowcaseSection } from '../modules/categoryShowcase/components/CategoryShowcaseSection';
import { VideoPublic } from '../modules/vedios/components/VideoPublic';
import ProductCatalogueSection from './ProductCatalogueSection';
import WhyChooseUs from './WhyChooseUs';
import { TestimonialsPublic } from '../modules/testimonials/components/TestimonialsPublic';

const STEPS = [
    {
        num: '01',
        color: '#1565c0',
        icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
            </svg>
        ),
        title: 'Requirement Gathering',
        desc: 'We analyze your design, quantity, quality specifications, and timeline requirements in detail.',
    },
    {
        num: '02',
        color: '#0097a7',
        icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
                <line x1="12" y1="22.08" x2="12" y2="12"/>
            </svg>
        ),
        title: 'Proposal & Contract',
        desc: 'Detailed proposal with pricing, timeline, and contract finalization for your project.',
    },
    {
        num: '03',
        color: '#7b1fa2',
        icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"/>
                <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                <line x1="11" y1="8" x2="11" y2="14"/>
                <line x1="8" y1="11" x2="14" y2="11"/>
            </svg>
        ),
        title: 'Sourcing & Sampling',
        desc: 'Fabric sourcing from mills, trims selection, and prototype development for your approval.',
    },
    {
        num: '04',
        color: '#e47911',
        icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="7" width="20" height="14" rx="2"/>
                <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
                <line x1="12" y1="12" x2="12" y2="16"/>
                <line x1="10" y1="14" x2="14" y2="14"/>
            </svg>
        ),
        title: 'Manufacturing',
        desc: 'Production across our distributed partner factories with centralized quality control.',
    },
    {
        num: '05',
        color: '#2e7d32',
        icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                <polyline points="9 12 11 14 15 10"/>
            </svg>
        ),
        title: 'Quality Control',
        desc: 'Multi-stage QC including fabric inspection, in-line checks, and final inspection reports.',
    },
    {
        num: '06',
        color: '#c62828',
        icon: (
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
                <rect x="1" y="3" width="15" height="13" rx="1"/>
                <path d="M16 8h4l3 5v3h-7V8z"/>
                <circle cx="5.5" cy="18.5" r="2.5"/>
                <circle cx="18.5" cy="18.5" r="2.5"/>
            </svg>
        ),
        title: 'Delivery & Support',
        desc: 'Timely delivery with packaging and post-delivery support for your complete satisfaction.',
    },
];
const ProcessSection = () => {
    return (
        <>
        <SeoHead {...HomeSeo} />

        {/* Page-level H1 for SEO + accessibility. Visually hidden because the
            brand identity is carried by the hero slider artwork; screen readers
            and crawlers still receive a descriptive top-level heading. */}
        <h1 className="visually-hidden">
            Arte Craft India — Manufacturer &amp; Exporter of Pom Poms, Tassels, Fringes,
            Faux Fur Pom Poms, Designer Tassels, Felt Pom Poms &amp; Beaded Patch Fringes in Delhi, India
        </h1>

        <HeroSliderPublic />

        <CategoryShowcaseSection compact />

        <ProductCatalogueSection />

        <WhyChooseUs />

        <TestimonialsPublic />

        <VideoPublic
            eyebrowLabel="FEATURED VIDEOS"
            sectionTitle="Our Story in Motion"
            sectionSubtitle="Watch how Arte Craft India crafts quality across every product line."
        />

        <section className="process-section">

            {/* Top gradient bar */}
            <div className="process-top-bar" />

            <div className="container">

                {/* ── Header ── */}
                <div className="process-header">
                    <span className="process-eyebrow">OUR PROCESS</span>
                    <h2 className="process-title">
                        How We Work
                        <span className="process-title-underline" />
                    </h2>
                    <p className="process-subtitle">
                        From idea to delivery, we ensure transparency and quality at every step
                    </p>
                </div>

                {/* ── Steps grid ── */}
                <div className="process-grid">

                    {/* Dashed connector row 1 */}
                    <div className="process-row-connector" aria-hidden="true" />

                    {STEPS.map(step => (
                        <div
                            key={step.num}
                            className="process-card"
                            style={{ borderLeftColor: step.color }}
                        >
                            {/* Ghost number watermark */}
                            <span className="process-ghost-num" aria-hidden="true">
                            {step.num}
                        </span>

                            {/* Step badge */}
                            <div
                                className="process-num"
                                style={{ background: step.color }}
                            >
                                {step.num}
                            </div>

                            {/* Icon */}
                            <div
                                className="process-icon-wrap"
                                style={{
                                    background: `${step.color}14`,
                                    border: `1px solid ${step.color}40`,
                                    color: step.color,
                                }}
                            >
                                {step.icon}
                            </div>

                            {/* Text */}
                            <h3 className="process-card-title">{step.title}</h3>
                            <p className="process-card-desc">{step.desc}</p>
                        </div>
                    ))}
                </div>

                {/* ── CTA ── */}
                <div className="process-cta">
                    <div className="process-cta-inner">
                        <p className="process-cta-label">Ready to bring your idea to life?</p>
                        <div className="process-cta-actions">
                            <a href="/request-a-quote" className="process-cta-btn-primary">
                                Request a Free Quote
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                     stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M5 12h14M12 5l7 7-7 7"/>
                                </svg>
                            </a>
                            <a href="/products" className="process-cta-btn-ghost">
                                Browse Products
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        </>
    );
};
export default ProcessSection;